export interface HistoricalLicense {
  licenseId: string;
  releaseChannelId: string;
  contentMetadataId: string;
  licenseName: string;
  issuingOrganizationId: string;
  assignedOrganizationId: string;
  startDate: Date;
  endDate?: Date;
}

export interface HistoricalSeatAllocation {
  licenseAllocationId: string;
  licenseId: string;
  licenseName: string;
  userId: string;
  createdAt: Date;
  originalExpiresAt?: Date;
  expiresAt?: Date;
  assignedOrganizationId: string;
}

export const isExternalLicense = (
  license: HistoricalLicense,
  companyId: string,
): boolean =>
  license.issuingOrganizationId === companyId &&
  license.assignedOrganizationId !== companyId;
